export const roleAllowsMultipleShifts = (role) => {
  if (!role || role.user_scope !== "all") return false;

  const scopes = Array.isArray(role.scopes) ? role.scopes : [];
  const shiftScopes = scopes.filter((scope) => scope.scope_type === "shift");

  if (shiftScopes.length === 0) return true;

  return shiftScopes.some((scope) => scope.scope_id === null || scope.scope_id === "*");
};
